export default __webpack_public_path__ + "static/media/sw-3.d8f26ae8.svg";